module.exports = __webpack_public_path__ + "img/powerpoint.5631130d.svg";